<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import StripeHeader from "stripe-header";
import VueButton from "vue-button";

export default {
  components: {
    StripeHeader,
    VueButton
  },
  mixins: [fandomBasicMixin],
  methods: {
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
  },
  computed: {
    style() {
      const style = {};
      if (!!this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }
      return style;
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : 8;
      return [
        `col-md-${columnWidth}`,
      ];
    },
  },
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()"
    :class="[contentType]"
    class="pb-4"
    :style="style"
    stripe-accordion-component
  >
    <div class="container py-4">
      <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
      <stripe-header :content="content" class="mb-4"></stripe-header>
      <div v-for="(item, index) in content.accordion" :key="`item-${index}`" class="row mx-0 justify-content-center">
        <a 
          :href="`#accordion-item-${index}`" 
          class="deco-none col-12 accordion-item collapsed"
          :class="columnClasses"
          data-toggle="collapse" 
        >
          <div class="item-title d-flex my-4 justify-content-between align-items-center">
            <span class="question">{{item.title}}</span>
            <div class="icon-container d-flex justify-content-center align-items-center">
              <i class="far fa-chevron-down"></i>
            </div>
          </div>
        </a>
        <div class="collapse col-12" :class="columnClasses" :id="`accordion-item-${index}`">
          <div class="bg-cover-center ar-16by9 mb-4" :style="{'background-image': getContentResponsiveImageURL('image', item)}" v-if="item.image"></div>
          <p class="mb-4" v-html="item.description"></p>
          <vue-button
            tag="a"
            :button="item.button"
            :buttonClass="`btn ${item.button_class || 'btn-primary'}`"
            v-if="item.button"
            class="mb-4"
          ></vue-button>
        </div>
        <div class="col-12" :class="columnClasses"><div class="separator w-100"></div></div>
      </div>
      <div class="row mx-0 justify-content-center mt-5">
        <div :class="columnClasses" class="col-12 d-flex justify-content-center">
          <vue-button
            tag="a"
            :button="content.button"
            buttonClass="btn btn-primary"
            v-if="content.button"
          ></vue-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-accordion-component] {
  .separator {
    height: 1px;
    background-color: $gray-400;
  }

  .accordion-item .far {
    transition: all $animation-time-fast;
    font-size: 1.25rem;
  }

  .accordion-item:not(.collapsed) .far {
    transform: rotate(180deg);
  }

  .icon-container {
    width: 1.75rem;
    height: 1.75rem;
  }

  .question {
    max-width: calc(100% - 3.75rem);
    font-weight: bold;
    font-size: 1.25rem;
  }

}
</style>
